import { render, staticRenderFns } from "./BlockViewer.vue?vue&type=template&id=fcdaf314"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"
import style0 from "./BlockViewer.vue?vue&type=style&index=0&id=fcdaf314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports